import firebase from "firebase/compat/app"

import { JsonTimestamp } from "../../common/types"

export type Timestamp = firebase.firestore.Timestamp
export type FieldValue = firebase.firestore.FieldValue

export function getFirestoreTimestamp(timestamp: Timestamp | FieldValue | JsonTimestamp) {
  if ("toDate" in timestamp || "delete" in timestamp) {
    return timestamp
  }
  return new firebase.firestore.Timestamp(
    (timestamp as JsonTimestamp).seconds,
    (timestamp as JsonTimestamp).nanoseconds,
  )
}

export function getFirestoreDate(timestamp: Date | JsonTimestamp | Timestamp) {
  if ("getDate" in timestamp) {
    return timestamp
  }
  return (getFirestoreTimestamp(timestamp) as Timestamp)?.toDate()
}
